import { useState } from 'react';
import './statistics.css';
import { useAuth } from '../context/context';
import { ChartSelector } from '../components/chartSelector';
import { SquaredIcon } from '../components/squaredIcon';
import { ReactComponent as SaveProceedingSVG } from '../images/saveProceeding.svg';
import ApexCharts from 'apexcharts';
import { get } from './utils/utils';
import generatePdfDocument from './generatePdfDocument';

export interface Chart {
  id: string;
  type: string;
  dateStart: Date | null;
  dateEnd: Date | null;
  mode: ChartMode;
  chartData?: any;
}

export enum ChartMode {
  'add',
  'select',
  'chart'
}

const initialState = {
  type: '',
  dateStart: null,
  dateEnd: null,
  mode: ChartMode.add
};

export function Statistics() {
  const { user } = useAuth();
  const [chart1, setChart1] = useState<Chart>({ ...initialState, id: '1' });
  const [chart2, setChart2] = useState<Chart>({ ...initialState, id: '2' });
  const [chart3, setChart3] = useState<Chart>({ ...initialState, id: '3' });
  const [chart4, setChart4] = useState<Chart>({ ...initialState, id: '4' });
  const [generateCharts, setGenerateCharts] = useState<boolean>(false);
  const [base64Charts, setBase64Charts] = useState<string[]>([]);

  function getChartData(value: Chart, setChartData: (data: any) => void) {
    if (
      value.dateStart &&
      value.dateStart instanceof Date &&
      value.dateEnd &&
      value.dateEnd instanceof Date &&
      value.type &&
      value.type !== '0' &&
      !value.chartData
    ) {
      const params = new URLSearchParams({
        dateStart: value.dateStart.toISOString().split('T')[0],
        dateEnd: value.dateEnd.toISOString().split('T')[0],
        type: value.type
      });
      get({
        url: 'statistics.php?' + params.toString(),
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          setChartData(data);
        })
        .catch((error) => {
          console.error('Error fetching options:', error);
        });
    }
  }

  async function generateImagesFromCharts() {
    const promiseArray = [];

    if (chart1.mode == ChartMode.chart && chart1.type !== '2') {
      promiseArray.push(ApexCharts.exec('chart1', 'dataURI'));
    } else {
      promiseArray.push(Promise.resolve(null));
    }
    if (chart2.mode == ChartMode.chart && chart2.type !== '2') {
      promiseArray.push(ApexCharts.exec('chart2', 'dataURI'));
    } else {
      promiseArray.push(Promise.resolve(null));
    }
    if (chart3.mode == ChartMode.chart && chart3.type !== '2') {
      promiseArray.push(ApexCharts.exec('chart3', 'dataURI'));
    } else {
      promiseArray.push(Promise.resolve(null));
    }
    if (chart4.mode == ChartMode.chart && chart4.type !== '2') {
      promiseArray.push(ApexCharts.exec('chart4', 'dataURI'));
    } else {
      promiseArray.push(Promise.resolve(null));
    }
    const result = await Promise.all(promiseArray);
    return result;
  }

  async function downloadPdf() {
    const base64ChartData = await Promise.all([
      ApexCharts.exec('chart1', 'dataURI'),
      ApexCharts.exec('chart2', 'dataURI'),
      ApexCharts.exec('chart3', 'dataURI'),
      ApexCharts.exec('chart4', 'dataURI')
    ]);
    console.log(base64ChartData);
    await generatePdfDocument([chart1, chart2, chart3, chart4], base64ChartData);
  }

  return (
    <div className="statistics-container">
      <div className="statistics-items">
        <div className="statistic-item">
          <ChartSelector
            value={chart1}
            setValue={setChart1}
            generate={generateCharts}
            getData={getChartData}
          />
        </div>
        <div className="statistic-item">
          <ChartSelector
            value={chart2}
            setValue={setChart2}
            generate={generateCharts}
            getData={getChartData}
          />
        </div>
      </div>
      <div className="statistics-items">
        <div className="statistic-item">
          <ChartSelector
            value={chart3}
            setValue={setChart3}
            generate={generateCharts}
            getData={getChartData}
          />
        </div>
        <div className="statistic-item">
          <ChartSelector
            value={chart4}
            setValue={setChart4}
            generate={generateCharts}
            getData={getChartData}
          />
        </div>
      </div>
      <div
        className="section-line"
        style={{ width: '100%', margin: '10px 0 10px 0' }}
      ></div>
      <div className="statistics-submit">
        {base64Charts &&
          (chart1.mode == ChartMode.chart ||
            chart2.mode == ChartMode.chart ||
            chart3.mode == ChartMode.chart ||
            chart4.mode == ChartMode.chart) && (
            <a href='#' onClick={() => downloadPdf()}>Descargar PDF</a>
          )}
        <div className="statistics-chart">
          <p><b>Generar selección</b></p>
          <button type="submit">
            <SquaredIcon
              onClick={() => {
                setGenerateCharts(!generateCharts);
                generateImagesFromCharts();
              }}
              icon={<SaveProceedingSVG className="clickable" />}
            />
          </button>
        </div>
      </div>

      {/* {base64Charts && base64Charts.length > 0 && (
        <PDFViewer>
          <StatisticsPDF values={[chart1, chart2, chart3, chart4]} base64Charts={base64Charts} additionalData={additionalData} />
        </PDFViewer>
      )} */}
    </div>
  );
}
